<template>
  <v-ons-page id="filter_page">
    <v-ons-toolbar v-show="isMobile">
      <div class="left" @click="popPage()">
        <div class="close">
          <img src="../assets/images/common/close.svg" alt="閉じる">
        </div>
      </div>
      <div class="center title">条件を絞り込む</div>
      <div class="right">
        <div class="clear" @click="allClear()">
          <span>クリア</span>
        </div>
      </div>
    </v-ons-toolbar>
    <header v-show="!isMobile">
      <div class="left"></div>
      <div class="center"><span>条件を絞り込む</span></div>
      <div class="right pc_close" @click="hideGrepFilterDialog()"><img src="../assets/images/common/close.svg" alt="閉じる"></div>
    </header>
    <div class="search_container">
      <div class="search_item">
        <h3>キーワードから探す</h3>
        <div class="search_text full">
          <div class="search_text_left">
            <img src="../assets/images/common/search_icon.svg" alt="検索">
            <input type="text" v-model="inputName" placeholder="店舗名・住所・店番など入力">
          </div>
          <div class="search_text_right">
            <div class="right_search">
              <button type="button" @click="pushSerchArea()">エリア</button>
            </div>
          </div>
        </div>
      </div>
      <div class="search_item">
        <h3>店舗・ATMの種類</h3>
        <div class="two_column">
          <div class="form_checkbox_mark">
            <input type="checkbox" v-model="shopTypeModel" id="type_tenpo" value="tenpo" @change="grep()">
            <label for="type_tenpo" class="low">
              <span>店舗</span>
            </label>
          </div>
          <div class="form_checkbox_mark">
            <input type="checkbox" v-model="shopTypeModel" id="type_atm" value="atm" @change="grep()">
            <label for="type_atm" class="low">
              <span>店外ATM</span>
            </label>
          </div>
        </div>
      </div>
      <div class="search_item">
        <h3>営業時間</h3>
        <div class="two_column">
          <div class="form_checkbox_mark">
            <input type="checkbox" id="time_1" v-model="openingTimeModel" value="current" @change="grep()">
            <label for="time_1">
              <span>現在営業中</span>
            </label>
          </div>
          <div class="form_checkbox_mark">
            <input type="checkbox" id="time_2" v-model="openingTimeModel" value="noon" @change="grep()">
            <label for="time_2">
              <span>お昼も開いて<br>いる店舗</span>
            </label>
          </div>
          <div class="form_checkbox_mark">
            <input type="checkbox" id="time_3" v-model="openingTimeModel" value="start_7" @change="grep()">
            <label for="time_3">
              <span>平日7時から<br>使える</span>
            </label>
          </div>
          <div class="form_checkbox_mark">
            <input type="checkbox" id="time_4" v-model="openingTimeModel" value="end_23" @change="grep()">
            <label for="time_4">
              <span>平日23時まで<br>使える</span>
            </label>
          </div>
          <div class="form_checkbox_mark">
            <input type="checkbox" id="time_5" v-model="openingTimeModel" value="saturday" @change="grep()">
            <label for="time_5">
              <span>土曜日に利用</span>
            </label>
          </div>
          <div class="form_checkbox_mark">
            <input type="checkbox" id="time_6" v-model="openingTimeModel" value="holiday" @change="grep()">
            <label for="time_6">
              <span>日曜・祝日に利用</span>
            </label>
          </div>
        </div>
      </div>
      
      <div class="search_item">
        <h3>ATM</h3>
        <div class="two_column">
          <div class="form_checkbox_mark">
            <input type="checkbox" id="atm_1" v-model="atmModel" value="kouka" @change="grep()">
            <label for="atm_1">
              <span>硬貨取扱あり<br>(平日18時まで)</span>
            </label>
          </div>
          <div class="form_checkbox_mark">
            <input type="checkbox" id="atm_2" v-model="atmModel" value="chucho" @change="grep()">
            <label for="atm_2">
              <span>通帳取扱あり</span>
            </label>
          </div>
          <div class="form_checkbox_mark">
            <input type="checkbox" id="atm_3" v-model="atmModel" value="kurikoshi" @change="grep()">
            <label for="atm_3">
              <span>通帳繰り越し<br>機能</span>
            </label>
          </div>
          <div class="form_checkbox_mark">
            <input type="checkbox" id="atm_4" v-model="atmModel" value="handicapped" @change="grep()">
            <label for="atm_4">
              <span>視覚障がい者<br>対応</span>
            </label>
          </div>
        </div>
      </div>

      <div class="search_item">
        <h3>相談専門拠点</h3>
        <div class="two_column">
          <div class="form_checkbox_mark">
            <input type="checkbox" id="special_1" v-model="specialtyModel" value="alpha" @change="grep()">
            <label for="special_1">
              <span>アルファ出張所<br>(資産運用相談)</span>
            </label>
          </div>
          <div class="form_checkbox_mark">
            <input type="checkbox" id="special_2" v-model="specialtyModel" value="inheritance" @change="grep()">
            <label for="special_2">
              <span>創業応援サロン</span>
            </label>
          </div>
          <div class="form_checkbox_mark">
            <input type="checkbox" id="special_3" v-model="specialtyModel" value="loan" @change="grep()">
            <label for="special_3">
              <span>ローン営業室</span>
            </label>
          </div>
          <div class="form_checkbox_mark">
            <input type="checkbox" id="special_4" v-model="specialtyModel" value="insurance" @change="grep()">
            <label for="special_4">
              <span>ほけんプラザ</span>
            </label>
          </div>
        </div>
      </div>
    </div>
    <v-ons-bottom-toolbar id="bottom_bar">
      <div class="search_bottom_result">
        <span class="all_clear sp_none" @click="allClear()">すべてクリア</span>
        <div class="bottom_bar_result">
          <div class="discover_count">
            <span>{{suggestCount}}</span>件見つかりました
          </div>
          <div>
            <button type="button" class="square_button orange_gradation" :disabled="suggestCount <= 0" @click="locationMap()">この条件で検索する</button>
          </div>
        </div>
      </div>
    </v-ons-bottom-toolbar>
  </v-ons-page>
</template>

<script>
import _ from 'lodash';
// import $ from "jquery";
import store from '../store/store';
import 'dayjs/locale/ja';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isBetween from 'dayjs/plugin/isBetween';
dayjs.locale('ja');
dayjs.extend(customParseFormat);
dayjs.extend(isBetween);

export default {
  name: 'GrepFilter',
  components: {
  },
  directives: {
  },
  props: {
    // shop: Array
  },
  computed: {
    isMobile: function() {
      return store.state.isMobile;
    },
    shops: function() {
      return store.getters.allStore;
    },
    isHoliday: function() {
      return store.getters.holiday
    }
  },
  watch: {
    isMobile: _.throttle(function(newVal, oldVal) {
      // PC -> SP
      if (newVal === true && oldVal === false) {
        store.dispatch('updateShowGrepFilterDialog', false);
      }

      // SP ->PC
      if (newVal === false && oldVal === true) {
        if (this.$router.currentRoute.name === 'GrepFilter' || this.$router.currentRoute.name === 'GrepInFilter') {
          this.popPage();
        }
      }
    }, 1000),
    inputName: function(newVal, oldVal) {
      this.grep();
    }
  },
  data() {
    return {
      suggestCount: 0,
      inputName: '',
      shopTypeModel: [],
      openingTimeModel: [],
      atmModel: [],
      specialtyModel: [],
      grepShops: [],
    };
  },
  methods: {
    popPage() {
      this.$router.back();
      // store.commit('pop');
    },
    /**
     * エリア検索画面へ遷移します
     */
    pushSerchArea() {
      if (this.isMobile) {
        this.$router.replace({name: 'SelectArea', params: {animation: 'lift'}});
      } else {
        store.dispatch('updateShowGrepFilterDialog', false);
        store.dispatch('updateShowSelectAreaDialog', true);
      }
    },
    /**
     * ダイアログを閉じます
     */
    hideGrepFilterDialog() {
      store.dispatch('updateShowGrepFilterDialog', false);
    },
    /**
     * 絞り込みを一括で行います
     */
    grep() {  
      let currentShops = _.clone(this.shops);
      let inputName = this.inputName || '';
      let shopType = this.shopTypeModel || [];
      let openingTime = this.openingTimeModel || [];
      let atm = this.atmModel || [];
      let specialty = this.specialtyModel || [];

      // キーワードでフィルタリング
      if (!_.isEmpty(inputName)) {
        currentShops = _.filter(currentShops, (shop) => {
          if (_.includes(shop.tenpo, inputName) || _.includes(shop.address, inputName) || _.includes(shop.rsv_t9, inputName)) {
            return shop;
          }
        });
      }

      // 店舗ATM種類でフィルタリング
      if (!_.isEmpty(shopType) && _.size(shopType) === 1) {
        currentShops = _.filter(currentShops, (shop2) => {
          if (shopType[0] === 'tenpo') {
            return shop2.siten_flg;
          } else {
            return !shop2.siten_flg;
          }
        });
      }

      // 営業時間でフィルタリング
      if (!_.isEmpty(openingTime)) {
        let currentDay;
        let currentTime = '';
        currentTime = dayjs();
        // console.log(currentTime);

        if (this.isHoliday) {
          currentDay = 7; // 祝日
        } else {
          currentDay = dayjs().day(); // 曜日 0(日曜日)~6(土曜日)
        }
        

        // DEBUG
        // currentDay = 0;

        currentShops = _.filter(currentShops, (shop3) => {
          if (this.checkOpeningTime(shop3, openingTime, currentDay, currentTime)) {
            return shop3;
          }
        });
      }

      // ATMでフィルタリング
      if (!_.isEmpty(atm)) {
        currentShops = _.filter(currentShops, (shop4) => {
          if (this.checkAtm(shop4, atm)) {
            return shop4;
          }
        });
      }

      // 相談専門拠点でフィルタリング
      if (!_.isEmpty(specialty)) {
        currentShops = _.filter(currentShops, (shop5) => {
          if (this.checkSpecialty(shop5, specialty)) {
            return shop5;
          }
        });
      }

      this.grepShops = currentShops;
      // console.log(this.grepShops);
      const allClearCheck = _.isEmpty(this.inputName) && _.isEmpty(this.shopTypeModel) && _.isEmpty(this.openingTimeModel) && _.isEmpty(this.atmModel) && _.isEmpty(this.specialtyModel) ? true : false;
      this.suggestCount = allClearCheck ? 0 : _.size(this.grepShops);
    },
    /**
     * 営業時間チェックボックスの絞り込み条件の可否を返却します
     */
    checkOpeningTime(shop, times, day, current) {
      let results = [];

      _.forEach(times, (type) => {
        switch(type) {
          case 'current': {
            if (shop.siten_flg) {
              // 店舗
              switch(day) {
                case 6: // 土曜日
                  if (shop.saturday) {
                    const openingArray = _.split(_.replace(shop.saturday, '：', ':'), '～');
                    const formatTime = _.map(openingArray, (time) => {
                      return dayjs(time, 'HH:mm');
                    });
                    
                    // 昼休憩チェック
                    if (!_.isEmpty(shop.rest)) {
                      // 昼休憩有り
                      const restTimeArray = _.split(_.replace(shop.rest, '：', ':'), '～');
                      const formatRestTime = _.map(restTimeArray, (time) => {
                        return dayjs(time, 'HH:mm');
                      });
                      const restCheck = current.isBetween(formatRestTime[0], formatRestTime[1]);
                      if (restCheck) {
                        results.push(false);  
                      } else {
                        results.push(current.isBetween(formatTime[0], formatTime[1]));
                      }
                    } else {
                      // 昼休憩無し
                      results.push(current.isBetween(formatTime[0], formatTime[1]));
                    }
                  } else {
                    results.push(false);
                  }
                  break;

                case 0: // 日曜日
                  if (shop.sunday) {
                    const openingArray = _.split(_.replace(shop.sunday, '：', ':'), '～');
                    const formatTime = _.map(openingArray, (time) => {
                      return dayjs(time, 'HH:mm');
                    });
                    
                    // 昼休憩チェック
                    if (!_.isEmpty(shop.rest)) {
                      // 昼休憩有り
                      const restTimeArray = _.split(_.replace(shop.rest, '：', ':'), '～');
                      const formatRestTime = _.map(restTimeArray, (time) => {
                        return dayjs(time, 'HH:mm');
                      });
                      const restCheck = current.isBetween(formatRestTime[0], formatRestTime[1]);
                      if (restCheck) {
                        results.push(false);  
                      } else {
                        results.push(current.isBetween(formatTime[0], formatTime[1]));
                      }
                    } else {
                      // 昼休憩無し
                      results.push(current.isBetween(formatTime[0], formatTime[1]));
                    }
                  } else {
                    results.push(false);
                  }
                  break;

                case 7: // 祝日
                  if (shop.holiday) {
                    const openingArray = _.split(_.replace(shop.holiday, '：', ':'), '～');
                    const formatTime = _.map(openingArray, (time) => {
                      return dayjs(time, 'HH:mm');
                    });
                    
                    // 昼休憩チェック
                    if (!_.isEmpty(shop.rest)) {
                      // 昼休憩有り
                      const restTimeArray = _.split(_.replace(shop.rest, '：', ':'), '～');
                      const formatRestTime = _.map(restTimeArray, (time) => {
                        return dayjs(time, 'HH:mm');
                      });
                      const restCheck = current.isBetween(formatRestTime[0], formatRestTime[1]);
                      if (restCheck) {
                        results.push(false);  
                      } else {
                        results.push(current.isBetween(formatTime[0], formatTime[1]));
                      }
                    } else {
                      // 昼休憩無し
                      results.push(current.isBetween(formatTime[0], formatTime[1]));
                    }
                  } else {
                    results.push(false);
                  }
                  break;

                default: // 平日
                  if (shop.rsv_t4) {
                    const openingArray = _.split(_.replace(shop.rsv_t4, '：', ':'), '～');
                    const formatTime = _.map(openingArray, (time) => {
                      return dayjs(time, 'HH:mm');
                    });
                    
                    // 昼休憩チェック
                    if (!_.isEmpty(shop.rest)) {
                      // 昼休憩有り
                      const restTimeArray = _.split(_.replace(shop.rest, '：', ':'), '～');
                      const formatRestTime = _.map(restTimeArray, (time) => {
                        return dayjs(time, 'HH:mm');
                      });
                      const restCheck = current.isBetween(formatRestTime[0], formatRestTime[1]);
                      if (restCheck) {
                        results.push(false);  
                      } else {
                        results.push(current.isBetween(formatTime[0], formatTime[1]));
                      }
                    } else {
                      // 昼休憩無し
                      results.push(current.isBetween(formatTime[0], formatTime[1]));
                    }
                  } else {
                    results.push(false);
                  }
                  break;
              }
            } else {
              // ATM
              switch(day) {
                case 6: // 土曜日
                  if (shop.day_sat) {
                    const openingArray = _.split(_.replace(shop.day_sat, '：', ':'), '～');
                    const formatTime = _.map(openingArray, (time) => {
                      return dayjs(time, 'HH:mm');
                    });
                    
                    results.push(current.isBetween(formatTime[0], formatTime[1]));
                  } else {
                    results.push(false);
                  }
                  break;

                case 0: // 日曜日
                  if (shop.day_sun) {
                    const openingArray = _.split(_.replace(shop.day_sun, '：', ':'), '～');
                    const formatTime = _.map(openingArray, (time) => {
                      return dayjs(time, 'HH:mm');
                    });
                    
                    results.push(current.isBetween(formatTime[0], formatTime[1]));
                  } else {
                    results.push(false);
                  }
                  break;

                case 7: // 祝日
                  if (shop.day_holiday) {
                    const openingArray = _.split(_.replace(shop.day_holiday, '：', ':'), '～');
                    const formatTime = _.map(openingArray, (time) => {
                      return dayjs(time, 'HH:mm');
                    });
                    
                    results.push(current.isBetween(formatTime[0], formatTime[1]));
                  } else {
                    results.push(false);
                  }
                  break;

                default: // 平日
                  if (shop.day_normal) {
                    const openingArray = _.split(_.replace(shop.day_normal, '：', ':'), '～');
                    const formatTime = _.map(openingArray, (time) => {
                      return dayjs(time, 'HH:mm');
                    });
                    
                    results.push(current.isBetween(formatTime[0], formatTime[1]));
                  } else {
                    results.push(false);
                  }
                  break;
              }
            }
            break;
          }

          case 'noon': {
            if (shop.siten_flg) {
              const restCheck = _.isEmpty(shop.rest) ? true : false;
              results.push(restCheck);
            } else {
              results.push(false);
            }
            break;
          }

          case 'start_7': {
            results.push(shop.morning_time);
            break;
          }

          case 'end_23': {
            results.push(shop.evening_time);
            break;
          }

          case 'saturday': {
            results.push(shop.saturday_time);
            break;
          }

          case 'holiday': {
            results.push(shop.sunday_time);
            break;
          }
        }
      });
      const checkResult = _.every(results);
      return checkResult;
    },
    /**
     * ATMチェックボックスの絞り込み条件の可否を返却します
     */
    checkAtm(shop, atms) {
      let results = [];
      _.forEach(atms, (type) => {
        switch(type) {
          case 'kouka': {
            results.push(shop.kouka_nyusyutu);
            break;
          }

          case 'chucho': {
            results.push(shop.chucho_toriatukai);
            break;
          }

          case 'kurikoshi': {
            results.push(shop.chucho_flg);
            break;
          }

          case 'handicapped': {
            results.push(shop.disabilities_flg);
            break;
          }
        }
      });
      const checkResult = _.every(results);
      return checkResult;
    },
    /**
     * 相談専門拠点チェックボックスの絞り込み条件の可否を返却します
     */
    checkSpecialty(shop, specialtys) {
      let results = [];
      _.forEach(specialtys, (type) => {
        switch(type) {
          case 'alpha': {
            results.push(shop.alpha);
            break;
          }

          case 'inheritance': {
            results.push(shop.inheritance);
            break;
          }

          case 'loan': {
            results.push(shop.loan);
            break;
          }

          case 'insurance': {
            results.push(shop.insurance);
            break;
          }
        }
      });
      const checkResult = _.every(results);
      return checkResult;
    },
    /**
     * 全てクリアします
     */
    allClear() {
      this.inputName = '';
      this.shopTypeModel = [];
      this.openingTimeModel = [];
      this.atmModel = [];
      this.specialtyModel = [];
      this.suggestCount = 0;
    },
    /**
     * 地図画面に遷移します
     */
    locationMap() {
      if (_.size(this.grepShops) > 0) {
        const ids_org = _.map(this.grepShops, 'id');
        store.dispatch('updateShowGrepFilterDialog', false);
        
        const typeParam = {
          'type': 'filter',
          'text': '絞り込み検索結果'
        }
        store.dispatch('updateSearchType', typeParam);
        let ids=_.clone(ids_org)
        if(this.inputName==="天神"){
          ids=ids_org.filter((d)=>d!="1344"&&d!="244");
        }else if(this.inputName==="博多"){
          ids=ids_org.filter((d)=>d!="481");
        }
        store.dispatch('updateResult', ids);
        if (this.isMobile) {
          this.$router.replace({name: 'Map', params: {animation: 'slide'}}).catch(err => {});
        } else {
          if (this.$router.currentRoute.name === 'Map') {
            this.$router.replace({name: 'Map', params: {animation: 'slide'}}).catch(err => {});
          } else {
            this.$router.push({name: 'Map', params: {animation: 'slide'}}).catch(err => {});
          } 
        }
      }
    }
  },
  mounted: function() {
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/styles/grep_filter.scss";
</style>